module.exports = __webpack_public_path__ + "sq14-6a0c040d.png";